<template>
  <span v-if="content" v-tippy="tippyOptions" :content="content">
    <slot />
  </span>

  <span v-else-if="force">
    <slot />
  </span>
</template>

<script>
import VueTippy from 'vue-tippy'
import Vue from 'vue'

Vue.use(VueTippy)

export default {
  props: {
    force: { type: Boolean, default: false },
    content: { type: String, default: null },
    options: { type: Object, default: () => ({}) },
  },

  computed: {
    tippyOptions() {
      return {
        animation: 'scale',
        duration: 200,
        arrow: true,
        delay: [0, 50],
        arrowType: 'sharp',
        theme: 'light',
        maxWidth: 220,
        ...this.options,
      }
    },
  },
}
</script>
